import {init} from "@rematch/core";
import {itemsJsonState, serversData, setsJsonState, siteData, skillsJsonState} from "./models";

const models = {
    siteData,
    serversData,
    skillsJsonState,
    setsJsonState,
    itemsJsonState
}

const store = init({models});
export default store;